export const UPDATA_RECORD_DATA = 'personMainPage/UPDATA_RECORD_DATA';
const initialState = {
    RecordData:{
        personPropertyCheck:[],
        personEntrust:{
            feeds:[]
        },
        personQiuzu:[],
        MyContract:[]
    }
};
const RecordDataReducer =  (RecordData={}, action)=>{
    switch (action.type) {
        case UPDATA_RECORD_DATA:
            return {
                ...RecordData,
                [action.subType]:action.data
            };
        default:
            return RecordData
    }
}
export default (state = initialState, action) => {
    return {
        RecordData : RecordDataReducer(state.RecordData, action),
    };
}

export const dispatch_func = {
    update_recordData : (data,type) => {
        return dispatch => {
            dispatch({
                type: UPDATA_RECORD_DATA,
                data:data,
                subType:type
            });
        }
    },
};


// WEBPACK FOOTER //
// ./src/modules/personMainPage.js